<div class="card-header">
  <app-breadcrumb currentPage="Regels"></app-breadcrumb>
</div>
<div class="card-body">
  <div class="float-right">
    <mat-paginator [length]="totalElements"
                   [pageSize]="pageSize"
                   [pageSizeOptions]="pageSizeOptions"
                   (page)="pageEvent = updatePage($event)">
    </mat-paginator>
  </div>
  <button class="btn plus float-right" (click)="addRule()">regel aanmaken</button>

  <table matSort (matSortChange)="sortPage($event)" class="table table-hover">
    <thead>
    <tr>
      <th mat-sort-header="subcategory.category.name">category</th>
      <th mat-sort-header="subcategory.name">subcategory</th>
      <th mat-sort-header="description">description</th>
      <th mat-sort-header="iban">IBAN</th>
      <th mat-sort-header="ibanRequiredEmpty" style="min-width:180px;">iban_required_empty</th>
      <th></th>
    </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of content" class="pointer">
        <td>{{row.type}}</td>
        <td>{{row.subCategoryName}}</td>
        <td>{{row.description}}</td>
        <td>{{row.iban}}</td>
        <td>{{row.ibanRequiredEmpty ? "Ja" : "Nee"}}</td>
        <td class="text-right">
          <mat-icon class="pointer icon-hover" (click)="delete(row.id)">close</mat-icon>
        </td>
      </tr>
    </tbody>
  </table>
</div>
